import React from 'react';

import { Col, Cols, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';

export const ResponsiveDemo = () => {
  return (
    <Cols
      responsive
      style={{ backgroundColor: 'lightgray' }}
      largeStyle={{ backgroundColor: 'lightyellow' }}
      mediumStyle={{ backgroundColor: 'lightcoral' }}
      rowBreakSize='medium'
    >
      <Col flex>
        <Rows>
          <Row>
            <Text subheader>Responsive Demo</Text>
          </Row>
          <Row>
            <Text small>
              {`The simplest way to add responsive styling within a Layout Component is to first add the 'responsive' prop.
              This will enable the component to invoke the useBaseState hook which will track the browser's width.
              We want to use the 'reponsive' prop only when needed in order to limit the renders as much as possible.
              The inclusion of the 'responsive' prop will allow you to use the multiple style props for different browser sizes.
              For example, 'mediumStyle={{backgroundColor: 'yellow'}}' would make it so that whenever the browser width is medium or smaller, the background color will be yellow.
              Each smaller style can overwrite the larger style if the same css props are used.
              Another prop (this actually does not need the 'responsive' prop) is rowBreakSize (for <Cols>).
              This will allow you to send a mediaSize slug to change the flex direction at that size.
              eg. 'rowBreakSize="medium"
              <Panels> also has something similar called 'flexDirectionBreakSize'.
              Reference the alongside code and adjust your browser width to see an example.`}
            </Text>
          </Row>
        </Rows>
      </Col>
      <Col flex>
        <Rows>
          <Row>
            <Text subheader>Example Code</Text>
          </Row>
          <Row>
            <Text small bold>{`<Cols`}</Text>
            <Text small bold style={{ paddingLeft: spacing.small }}>
              responsive
            </Text>
            <Text
              small
              bold
              style={{ paddingLeft: spacing.small }}
            >{`style={{ backgroundColor: 'lightgray' }}`}</Text>
            <Text
              small
              bold
              style={{ paddingLeft: spacing.small }}
            >{`largeStyle={{ backgroundColor: 'lightyellow' }}`}</Text>
            <Text
              small
              bold
              style={{ paddingLeft: spacing.small }}
            >{`mediumStyle={{ backgroundColor: 'lightred' }}`}</Text>
            <Text small bold style={{ paddingLeft: spacing.small }}>
              rowBreakSize='medium'
            </Text>
            <Text small bold>{`>`}</Text>
          </Row>
        </Rows>
      </Col>
    </Cols>
  );
};
